module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"done":"C\u0027est fait !"}}')
  delete Component.options._Ctor
}
